import { share } from 'rxjs/operators/share';
import { interval } from 'rxjs/observable/interval';
import { startWith } from 'rxjs/operators/startWith';

export class IntervalService {
    interval10 = interval(10000)
        .pipe(
            share(), // make all subscriptions synchronous
            startWith(null),
        );
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/services/interval.ts